


$( "#selling_plan_onetime" ).click(function() {
  $( "#discounted_price" ).hide();
  $( ".rc_label__frequency" ).hide();
  $( "#__product-subscription-info" ).hide();
  $( "#non_discounted_price" ).show();
  $('.product-form__cart-submit span').text('Add to Cart');
});
  
$( ".subtoggle" ).click(function() {
  $( "#discounted_price" ).show();
  $( "#non_discounted_price" ).hide();
    $( ".rc_label__frequency" ).show();
  $( "#__product-subscription-info" ).show();
  $('.product-form__cart-submit span').text('Subscribe Now');
});  




$(document).ready(function(){
  
  if($("input:radio[class='className']").is(":checked")) {
     //write your code         
}
  
  
    if (!$("input[id='selling_plan_onetime']:checked").val()) {
         $( "#discounted_price" ).show();
  $( "#non_discounted_price" ).hide();
    }
    else {
        $( "#discounted_price" ).hide();
  $( "#non_discounted_price" ).show();
    }
});



window.onload=function() {
  var rads = document.getElementsByName("selling_plan");
  for (var i=0;i<rads.length;i++) {
  
    if (rads[i].checked) {
      rads[i].click();
    }
  }
};


window.onload=function() {
  var rads = document.getElementsByClassName("recheck");
  for (var i=0;i<rads.length;i++) {
  
    if (rads[i].checked) {
      rads[i].click();
    }
  }
};

